<template>
  <router-view></router-view>
</template>

<script>
  export default {
    mounted () {
      // this.$notify(
      //   {
      //     component: NotificationSample,
      //     icon: 'nc-icon nc-app'
      //   })
    }
  }
</script>
